export const en = {
    // Header
    'header.title': '🎭 Kean Unmasked',
    'header.subtitle': 'Tom Kean Jr. (NJ-7) — Does not care about your healthcare.',

    // Hero Section
    'hero.quote': 'Tom Kean Jr.: "I tell voters I\'m independent. Then I vote with MAGA."',
    'hero.subtext': '4 Republicans Broke Ranks to Save ACA Subsidies. On December 17th, 4 GOP lawmakers showed courage and joined Democrats to force a vote. Tom Kean Jr. (NJ-7)? He stayed silent. In December, Kean added his name to a GOP call with 17 Republican senators to extend ACA subsidies — but he still voted with House Republicans to block the extension. 22 million Americans face premium increases of 114% starting January 1st.',

    // Breaking News
    'breaking.news': '🚨 BREAKING: Bloomberg: Americans Worry More About Health Care Costs Than Gas or Groceries',

    // Kean Did Not Support Section
    'kean.betrayal.title': 'TOM KEAN JR. REFUSED TO STAND UP FOR YOU',
    'kean.betrayal.text': 'On December 17th, 4 Republicans from swing districts (Brian Fitzpatrick, Rob Bresnahan Jr., Ryan Mackenzie of PA, and Mike Lawler of NY) bucked their party and joined Democrats to force a vote on extending ACA subsidies. Rep. Tom Kean Jr. (NJ-7) was NOT one of them. He chose party loyalty over your healthcare.',
    'kean.betrayal.comparison': 'These 4 Republicans showed courage. Kean showed cowardice.',
    'kean.betrayal.cta': 'Ask Kean: Why Didn\'t You Stand Up For Us?',

    // Healthcare Context Section
    'context.title': 'Republicans Don\'t Care About Your Healthcare: A "Tsunami of Health Costs" Is Now Upon Us',
    'context.intro': 'Republican Congressman Tom Kean Jr. (NJ-7) has done nothing to support your healthcare. Get ready to pay more for everything: premiums, doctor visits, prescriptions. How are you going to afford this? On December 16th, House Republicans voted down a Democratic effort to extend ACA subsidies. Democrats have been fighting for your healthcare — passing the ACA, lowering prescription drug prices for key medications, and more. But Tom Kean Jr. voted with his party to let these protections expire.',
    'context.truth.title': 'TRUTH: Real Impact on NJ Families',
    'context.truth.text': 'Mahwah, NJ resident Tina Jump learned her ACA premium will surge from <strong>$400/month to over $1,100/month</strong> — a nearly threefold increase. "I don\'t know how I\'m going to pay for this," she told CBS News.',
    'context.impact': '<strong>22 million Americans</strong> who qualify for tax credits now face tough financial decisions. Out-of-pocket premium costs will increase <strong>114% on average</strong>, hiking annual costs by $1,016. A family of four earning $75,000/year could see premiums rise by an additional <strong>$3,368</strong>.',
    'context.tsunami': '"We are going to see a tsunami of health costs increasing on January 1," said Michelle Sternthal of Community Catalyst. About <strong>4 million people could drop their health insurance</strong> due to higher premiums, according to the Congressional Budget Office.',
    'context.exposed.title': 'EXPOSED: Who\'s Most Vulnerable?',
    'context.exposed.text': 'Small business owners and self-employed workers are particularly at risk. About half of adults enrolled in the ACA are small business owners, employed by companies with fewer than 25 workers, or self-employed.',
    'context.accountability': 'Rep. Tom Kean Jr. (NJ-7) voted with his party to let these subsidies expire. Congressional Democrats are circulating a discharge petition to force a vote on extending ACA premium tax credits. The path to winning the House runs straight through New Jersey. It\'s time to hold him accountable.',
    'context.cta': 'Take Action Now',

    // ACA Section
    'aca.title': 'Republicans Are Taking Away Your Healthcare — ACA Subsidies Expired December 31st',
    'aca.text': 'House Republicans blocked the extension of ACA subsidies on December 16th. Starting January 1st, premiums will spike an average of 114%. Some families, like a Mahwah resident earning $72,000/year, will see costs nearly triple — from $400 to over $1,100 per month. Rep. Tom Kean Jr. (NJ-7) voted with his party to block this lifeline.',
    'aca.chart.title': 'Average Premium Increase',
    'aca.chart.2025': '2025',
    'aca.chart.2026': '2026',
    'aca.chart.withSubsidies': 'With Subsidies',
    'aca.chart.increase': '+114% Avg',

    // No Kean Day Section
    'nokean.title': 'NO KEAN DAY!',
    'nokean.date': 'February 7',
    'nokean.message': 'Send him a message!',
    'nokean.standup': 'STAND UP FOR HEALTHCARE',
    'nokean.handle': '@CongressmanKean',
    'nokean.caption': '"I avoid town halls because mirrors make me uncomfortable."',

    // Voting Record Section
    'voting.title': '📜 Receipts are Clear',
    'voting.record.title': 'Tom Kean Jr.\'s Voting Record',
    'voting.bill.name': 'H.R.1 - One Big Beautiful Bill Act',
    'voting.bill.congress': '119th Congress (2025-2026) | Public Law 119-21',
    'voting.bill.rollcall': 'Roll Call Vote #145 | May 22, 2025',
    'voting.bill.cut1': '• Cuts ACA subsidies - causing 174% premium increases',
    'voting.bill.cut2': '• Reduces Medicaid funding affecting NJ families',
    'voting.breakdown.title': 'VOTE BREAKDOWN',
    'voting.breakdown.yeas': '✓ Yeas: 215 (All Republicans)',
    'voting.breakdown.nays': '✗ Nays: 214 (All Democrats)',
    'voting.breakdown.present': 'Present: 1',
    'voting.breakdown.notvoting': 'Not Voting: 2',
    'voting.breakdown.passed': 'PASSED',
    'voting.kean.name': 'TOM KEAN JR.',
    'voting.kean.title': 'Representative, NJ-7',
    'voting.kean.vote': 'YEA',
    'voting.kean.result': 'VOTED TO CUT HEALTHCARE',
    'voting.source': 'Source: U.S. House of Representatives Office of the Clerk | clerk.house.gov/Votes/2025145',
    'voting.cta.vote': 'View Kean\'s Vote',
    'voting.cta.bill': 'Read the Bill (H.R.1)',

    // Medicaid Section
    'medicaid.title': 'Tom Kean Jr.: "I Call It \'Fiscal Responsibility\'"',
    'medicaid.text': 'Rep. Tom Kean Jr. (NJ-7) supported Medicaid cuts that threaten seniors, children, and people with disabilities. These cuts reduce access to doctors, hospitals, and long-term care. Every vote tells the truth — even if he doesn\'t.',
    'medicaid.visual': 'Medicaid = Lifeline',
    'medicaid.hashtags': '#KeanUnmasked #FollowTheMoney',
    'medicaid.hashtags.text': '#KeanUnmasked #FollowTheMoney #RepublicansDontCareAboutYourHealthcare',

    // Medicare Section
    'medicare.title': 'Tom Kean Jr.: "I Didn\'t Lose My Voice. I Gave It to Trump."',
    'medicare.subtext': 'Republican proposals include hundreds of billions in Medicare reductions. Rep. Tom Kean Jr. (NJ-7) has aligned with these efforts, threatening seniors\' healthcare.',
    'medicare.bullet1': 'GOP budget drafts propose $479 billion in Medicare cuts (payment structures, eligibility changes).',
    'medicare.bullet2': 'The "One Big Beautiful Bill Act" included provisions restricting Medicare access.',
    'medicare.bullet3': 'Seniors in NJ-7 rely on Medicare for hospital visits, prescriptions, and long-term care.',
    'medicare.cta': 'Protect Medicare — Take Action',
    'medicare.visual': 'Medicare = Lifeline.\nScan QR Code To Take Action.',

    // Accountability Section
    'accountability.title': 'The Mask Is Off. Hold Tom Kean Jr. Accountable.',
    'accountability.text': '"Sometimes silence isn\'t golden. It\'s cowardice dressed as caution." Rep. Tom Kean Jr.\'s (NJ-7) record is clear: higher costs, less care, more hardship. NJ-7 deserves better.',
    'accountability.cta': 'Join #FindingKeanFridays',

    // News Sources Section
    'news.title': '📰 More Receipts',
    'news.updated': 'Updated January 29, 2026',
    'news.cbs': 'CBS News: Millions Face Premium Spike',
    'news.wsj': 'WSJ: Insurers React to Medicare Payment Freeze',
    'news.bloomberg': 'Bloomberg: Health Costs Worry Americans Most',
    'news.nytimes': 'NY Times: 4 Republicans Buck Party to Force Vote',
    'news.nytimes2': 'NY Times: House Blocks Obamacare Subsidy Extension',
    'news.nytimes3': 'NY Times: Republicans Push Democrats\' Bid Over Finish Line',

    // Footer
    'footer.tagline': 'Truth Hurts. Lies Cost More. Republicans DON\'T Care About Your Healthcare.',
    'footer.hashtags': '#KeanUnmasked #NoKings #RepublicansDontCareAboutYourHealthcare',
    'footer.disclaimer': 'Truth Hurts. Lies Cost More. Republicans Don\'t Care About Your Healthcare. #KeanUnmasked #NoKings #RepublicansDontCareAboutYourHealthcare',
    'footer.terms': 'Terms of Use',
    'footer.privacy': 'Privacy Policy',
    'footer.contact': 'Contact',
};

export default en;
